import { Check } from 'lucide-react'

import type { Plan } from './types'
import { formatSoles } from './types'
import { formatBytes } from '../../lib/format'
import { Badge, Button, Card } from '../../ui'

export function PlanCard({
  plan,
  current,
  pending,
  busy,
  onChoose,
}: {
  plan: Plan
  current: boolean
  pending: boolean
  busy: boolean
  onChoose: () => void
}) {
  const features = [
    `${formatBytes(plan.max_storage_bytes)} de almacenamiento`,
    `${plan.max_users} ${plan.max_users === 1 ? 'usuario' : 'usuarios'}`,
    'Proyectos ilimitados',
    'Descargas sin coste',
  ]

  return (
    <Card highlighted={current} className="flex h-full flex-col p-4">
      <div className="flex items-baseline justify-between gap-2">
        <h3 className="text-subhead font-medium text-ink">{plan.name}</h3>
        {current && <Badge tone="accent">Actual</Badge>}
        {pending && !current && <Badge>Programado</Badge>}
      </div>

      <p className="mt-2 text-title font-semibold text-ink" data-numeric>
        {formatSoles(plan.price_net_cents)}
      </p>
      {/* Neto y con IGV a la vista: el estudio compara con la competencia por el
          precio de tarifa, pero lo que le llega al banco es el total. */}
      <p className="text-caption text-ink-subtle" data-numeric>
        + IGV · {formatSoles(plan.total_cents)} al mes
      </p>

      <ul className="mt-4 flex flex-1 flex-col gap-1.5">
        {features.map((feature) => (
          <li key={feature} className="flex items-start gap-2 text-body text-ink-muted">
            <Check
              size={15}
              strokeWidth={2.5}
              aria-hidden
              className="mt-1 shrink-0 text-positive"
            />
            {feature}
          </li>
        ))}
      </ul>

      <Button
        block
        variant={current ? 'secondary' : 'primary'}
        className="mt-4"
        disabled={current}
        busy={busy && 'Cambiando…'}
        onClick={onChoose}
      >
        {current ? 'Tu plan' : 'Cambiar a este plan'}
      </Button>
    </Card>
  )
}
